import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { userstate } from '@holmescorp/lcc-state';
import { publish } from '@holmescorp/pub-sub';

// CSS
import css from '../../css/posttest.m.css';
import { CardProperties } from '../../interfaces';
import { Card } from '../../widgets';

export interface PosttestCardProperties extends CardProperties {
	title: string;
	button_label?: string;
	button_label_complete?: string;
	subtitle?: string;
}

const factory = create({
	theme,
	userstate
}).properties<PosttestCardProperties>();

export const PosttestCard = factory(({ id, properties, middleware: { theme, userstate } }) => {
	const {
		mediaSrc = '',
		mediaTitle = '',
		title,
		subtitle = '',
		button_label = 'Begin',
		button_label_complete = 'Results'
	} = properties();
	const themeCss = theme.classes(css);

	const { get, path } = userstate;
	const posttest = get(path('posttest'));
	const passed = posttest.passed;

	const label = passed ? button_label_complete : button_label;

	return v('div', { id, classes: [theme.variant(), themeCss.root] }, [
		w(Card, { mediaSrc, mediaTitle }, [
			{
				content: v('div', { classes: [themeCss.content] }, [
					v('div', { classes: [themeCss.title] }, [title]),
					v('div', { classes: [themeCss.subtitle] }, [subtitle]),
					v('div', { classes: [themeCss.actions] }, [
						w(
							Button,
							{
								onClick: () => {
									publish('site/posttest');
								}
							},
							[
								{
									label
								}
							]
						)
					])
				])
			}
		])
	]);
});

export default PosttestCard;
